import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';

import { toastError, toastSuccess } from "../../utils/react-toaster";
import { deleteTaxAreaData, deleteTaxTypeData, getAllTaxAreasData, getAllTaxTypesData,
  saveAllTaxAreasData, saveAllTaxTypesData, saveTaxAreaData, saveTaxTypeData } from "../slices/taxes";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string,
  success?: boolean
  code?: any;
  results?: any;
  productvo?: any;
}


function* fetchAllTaxAreasData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.TAXES.getAllTaxAreasApi
    })
    if (response) {
      yield put(saveAllTaxAreasData({response}));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteTaxArea(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.TAXES.deleteTaxAreaApi(actions.payload.mid),
    })
    if (response.code) {
      toastError(response.code);
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* saveTaxArea(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.TAXES.saveTaxAreaApi,
      data: actions.payload.dataToPost
    })
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}


function* fetchAllTaxTypesData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.TAXES.getAllTaxTypesApi
    })
    if (response) {
      yield put(saveAllTaxTypesData({response}));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteTaxType(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.TAXES.deleteTaxTypeApi(actions.payload.mid),
    })
    if (response.code) {
      if (response.code === "REST_TAX_REFERENCE_IN_TAX_AREA") {
        toastError(`Tax can't be deleted as it is referenced in some tax area.`);
      } else {
        toastError(response.code);
      }
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* saveTaxType(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.TAXES.saveTaxTypeApi,
      data: actions.payload.dataToPost
    })
    actions.payload.callback(response);
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}


export default function* root() {
  yield takeEvery(saveTaxAreaData.type, saveTaxArea);
  yield takeEvery(getAllTaxAreasData.type, fetchAllTaxAreasData);
  yield takeEvery(deleteTaxAreaData.type, deleteTaxArea);

  yield takeEvery(saveTaxTypeData.type, saveTaxType);
  yield takeEvery(getAllTaxTypesData.type, fetchAllTaxTypesData);
  yield takeEvery(deleteTaxTypeData.type, deleteTaxType);
}

